<div fxLayout="column" class="full-width full-height">

  <app-page-header [section]="'Support'" [title]="'Contacting Customer Care for Support'"
                   [description]="'Get in touch with the right person at SOKO, we’re here to help.'"
                   [backgroundWhite]="true"></app-page-header>

  <div class="fx-row page-padding">
    <div class="fx-col">
      <mat-list>
        @for (section of sections; track section; let last = $last) {
          <div mat-subheader>{{ section.title }}</div>

          @for (content of section.content; track content) {
            <mat-list-item class="policies-list-item"
                           [class.active-selection]="content === selectedArticle"
                           (click)="current(content)">
              <mat-icon class="policies-list-icon" matListItemIcon>{{ section.icon }}</mat-icon>
              <div matListItemTitle class="policies-list-title">{{ content.title }}</div>
              <div matListItemLine class="policies-list-line">{{ content.description }}</div>
            </mat-list-item>
          }

          @if (!last) {
            <mat-divider></mat-divider>
          }
        }
      </mat-list>
    </div>

    <div class="policies-article-container">
      <ng-template appPolicyHost></ng-template>
    </div>
  </div>
</div>
